import {backendGetRequest} from './requests'
import {setMt5StdNetworkLimits} from './mt5StdNetworkLimitsCache'
import {MT5_STD_LIMIT_OVERRIDE_BY_NETWORK_IB_ID} from './mt5StdNetworkLimits'

export async function loadMt5StdNetworkLimits(): Promise<void> {
  try {
    const response = await backendGetRequest('/api/v2/dashboard/accounts/mt5-std-network-limits', true)
    if (!response.ok) return

    const body = await response.json()
    const limits = body?.limits
    if (limits == null || typeof limits !== 'object') return

    const parsed: Record<number, number> = {}
    Object.entries(limits).forEach(([remoteIbId, limit]) => {
      const id = Number(remoteIbId)
      const value = Number(limit)
      if (Number.isFinite(id) && Number.isFinite(value)) {
        parsed[id] = value
      }
    })

    setMt5StdNetworkLimits(parsed)
  } catch {
    setMt5StdNetworkLimits({...MT5_STD_LIMIT_OVERRIDE_BY_NETWORK_IB_ID})
  }
}
